import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './config/msalConfig';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '';

const WithGoogleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) =>
  GOOGLE_CLIENT_ID
    ? <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>{children}</GoogleOAuthProvider>
    : <>{children}</>;

// loginRedirect() keeps everything in the same tab, so the PKCE code verifier
// written to sessionStorage before navigation survives the Microsoft round-trip.
// MsalProvider calls handleRedirectPromise() automatically on mount.
const msalInstance = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

msalInstance.initialize().then(() => {
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <WithGoogleProvider>
          <App />
        </WithGoogleProvider>
      </MsalProvider>
    </React.StrictMode>
  );
}).catch(console.error);

reportWebVitals();
